import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import { getGridStringOperators } from "@mui/x-data-grid";
import MyTable from "../../Schedule/MyTable";
import ApiService from "../../../functions/apiService";
import { toast } from 'react-toastify';

export default function ExportConfTable() {
  // const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      Update: "EXPORT_DIFFERENCES",
    },
  });
  let columns = [
    {
      field: "Var",
      headerName: "Var",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "Value",
      headerName: "Value",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
  ];
  const onSubmit = (body) => {
    setLoading(true);
    ApiService.post("/exportConfigFile", body)
      .then(({ data }) => {
        setLoading(false);
        console.log("data", data);
        setModalData(data);
        setOpen(true);
        toast.success('Success')
        // enqueueSnackbar("success", { variant: "success" });
      })
      .catch(({ data }) => {
        setLoading(false);
        toast.error("Error")
        // enqueueSnackbar("Error", { variant: "error" });
      });
    console.log("body", body);
  };
  let closeModal = () => {
    setOpen(false);
  };
  return (
    <>
      <Typography fontWeight="700" fontSize="16px">
        Export _Config Table
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-12 col-md-6">
          <FormControl sx={{ gap: "12px" }}>
            <RadioGroup
              name="radio-buttons-group"
              row
              defaultValue={"EXPORT_DIFFERENCES"}
            >
              <FormControlLabel
                value="EXPORT_DIFFERENCES"
                {...register("Update")}
                control={<Radio />}
                label={
                  <Typography
                    sx={{
                      textTransform: "capitalize",
                      fontSize: '14px'
                    }}
                  >
                    Differences
                  </Typography>
                }
              />
              <FormControlLabel
                value="EXPORT_DEFAULTS"
                {...register("Update")}
                control={<Radio />}
                label={
                  <Typography
                    sx={{
                      textTransform: "capitalize",
                      fontSize: '14px'
                    }}
                  >
                    Defaults
                  </Typography>
                }
              />
            </RadioGroup>
          </FormControl>
        </div>

        <div className="col-12 mt-2">
          <ButtonTheme disabled={loading} type="submit" color="primary">
            Export Config
          </ButtonTheme>
        </div>
      </form>
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "90vw" } }}
        maxWidth="lg"
        open={open}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Variables</DialogTitle>
        <DialogContent>
          <MyTable
            rows={modalData}
            columns={columns}
            useTopFilter={false}
            checkboxSelection={false}
            hideFooter={true}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
